import { css } from 'lit';

export default css`
  :host {
    --synapse-frame-color: var(--synapse-color-neutral-3);
    --synapse-panel-color: var(--synapse-color-neutral-1);
    --synapse-text-color: var(--synapse-color-neutral-7);

    /* Fonts */
    --synapse-font-family-primary: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
      'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    font-family: var(--synapse-font-family-primary);
  }
`;
